import { render, staticRenderFns } from "./SubAccountAdd.vue?vue&type=template&id=561b7f54&"
import script from "./SubAccountAdd.vue?vue&type=script&lang=js&"
export * from "./SubAccountAdd.vue?vue&type=script&lang=js&"
import style0 from "./SubAccountAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports